import { MyAccountContainer } from '../containers/MyAccountContainer/index'

export const MyAccountPage = () => (
    <MyAccountContainer/>
)